I<template>
  <div class="home-v2">
    <div class="modal-level2">
      <div class="modal-level2-top">
        <Sidebar />
        <div class="level2-right">
          <transition name="component-fade" mode="out-in">
            <keep-alive>
              <component :is="activeTab" />
            </keep-alive>
          </transition>
        </div>
      </div>
      <component :is="activeBottom" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Validation',
  components: {
    Sidebar: () => import('@/components/V2/ModalValidationSidebar'),
    ProfileBottom: () => import('@/components/V2/Profile-Bottom.vue'),
  },
  computed: {
    activeTab() {
      const tab = this.$store.state.level1.activeTab

      switch (tab) {
        case 'profil':
          return () => import('@/views/V2/Profile.vue')
          break
        case 'informasi':
          return () => import('@/views/V2/Informasi.vue')
          break
        case 'legaldoc':
          return () => import('@/views/V2/LegalDocument.vue')
          break
        default:
          break
      }
    },
    activeBottom() {
      const tabBottom = this.$store.state.level1.activeTab

      switch (tabBottom) {
        case 'profil':
          return () => import('@/components/V2/Profile-Bottom.vue')
          break
        case 'informasi':
          return () => import('@/components/V2/Profile-Bottom.vue')
          break
        case 'legaldoc':
          return () => import('@/components/V2/Profile-Bottom.vue')
          break
        // case 'informasi':
        //   return () => import('@/components/V2/Information-Bottom.vue')
        //   break
        // case 'legaldoc':
        //   return () => import('@/components/V2/LegalDoc-Bottom.vue')
        //   break
        default:
          break
      }
    },
  },
  methods: {},
}
</script>
